import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { translations } from '@minifinder/resources';

const SUPPORTED_LANG_LIST = ['en', 'sv', 'da', 'de', 'es', 'fi', 'fr', 'it', 'no', 'pl', 'el'];
const DEFAULT_LANGUAGE = 'en';

// eslint-disable-next-line import/no-named-as-default-member
i18n.use(initReactI18next).init({
    compatibilityJSON: 'v3',
    resources: {
        ...Object.entries(translations).reduce(
            (acc, [key, value]) => ({
                ...acc,
                [key]: {
                    translation: value,
                },
            }),
            {},
        ),
    },
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANG_LIST,
    keySeparator: '.',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
